import { render, staticRenderFns } from "./BlogpostList.vue?vue&type=template&id=44a7e68e&"
import script from "./BlogpostList.vue?vue&type=script&lang=js&"
export * from "./BlogpostList.vue?vue&type=script&lang=js&"
import style0 from "./BlogpostList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BlogpostList.vue"
export default component.exports